import { create } from "zustand";
import type { Attempt, Progress } from "@/core/data/types";
import {
  getProgress,
  recordCompletion,
  xpForLevel,
  type CompletionResult,
} from "@/core/data/db";

interface ProgressState {
  progress: Progress;
  loaded: boolean;
  load: () => Promise<void>;
  complete: (attempt: Attempt, xpGained: number) => Promise<CompletionResult>;
  /** Progress (0..1) toward the next level. */
  levelProgress: () => number;
}

const INITIAL: Progress = {
  id: "singleton",
  xp: 0,
  level: 1,
  streakDays: 0,
  lastActiveDate: null,
  totalCompleted: 0,
};

export const useProgressStore = create<ProgressState>((set, get) => ({
  progress: INITIAL,
  loaded: false,
  load: async () => {
    const progress = await getProgress();
    set({ progress, loaded: true });
  },
  complete: async (attempt, xpGained) => {
    const result = await recordCompletion(attempt, xpGained);
    set({ progress: result.progress });
    return result;
  },
  levelProgress: () => {
    const { xp, level } = get().progress;
    const floor = xpForLevel(level);
    const ceil = xpForLevel(level + 1);
    if (ceil <= floor) return 0;
    return Math.min(1, Math.max(0, (xp - floor) / (ceil - floor)));
  },
}));
